<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap class="mt-3 mb-2 mt-sm-0">
      <v-flex xs12 sm8 md4 lg6>
        <h4 class="dark--text font-weight-bold">Plan switch report</h4>
      </v-flex>
    </v-layout>

    <v-layout class="mt-6 ms-n5 ps-5 ps-sm-0" wrap>
      <v-flex xs8 sm3 md3 lg2 class="mt-5 mt-sm-0 ms-sm-5 me-5">
        <v-select :items="fieldsToSearch" v-model="fieldToSearch" item-text="key" item-value="value" label="Field To Search" dense attach solo></v-select>
      </v-flex>
      <v-flex xs8 sm3 md1 lg2 class="ml-2">
        <v-text-field placeholder="Search.." v-model="search" solo dense> </v-text-field>
      </v-flex>
      <v-flex xs8 sm3 md3 lg2 class="mt-5 mt-sm-0 ms-sm-5 me-5">
        <v-select :items="paymentStatuses" v-model="paymentStatus" clearable chips label="Payment Status" dense attach solo></v-select>
      </v-flex>

      <v-flex xs8 sm3 md1 lg3 class="ml-2">
        <v-btn class="ms-sm-5 light--text text-capitalize" color="primary" width="150" @click="getPlanSwitchHistory">Search </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="history"
      class="mt-2 elevation-1"
      :mobile-breakpoint="0"
      :items-per-page="25"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItems"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:[`item.siNo`]="{ item }">
        {{
          history
            .map(function(x) {
              return x._id;
            })
            .indexOf(item._id) + 1
        }}
      </template>

      <template v-slot:[`item.updatedBy`]="{ item }">
        <span v-if="item.updatedBy"> {{ item.updatedBy.firstnameEn }} {{ item.updatedBy.lastnameEn }} </span>
      </template>
      <template v-slot:[`item.customer`]="{ item }">
        <span v-if="item.customer"> {{ item.customer.user.firstnameEn }} {{ item.customer.user.lastnameEn }} </span>
      </template>

      <template v-slot:[`item.customer`]="{ item }">
        <router-link
          v-if="!item.is_deleted"
          :to="{
            name: 'CustomerDetails',
            params: { customerId: item.customer._id },
            query: { customerId: item.customer._id },
          }"
          class="mx-auto"
        >
          {{ toTitleCase(item.customer.user.firstnameEn) }}
          {{ toTitleCase(item.customer.user.lastnameEn) }}
          <!-- <div class="mx-1" /> -->
        </router-link>

        <span v-else>
          <!-- <div class="mx-1" /> -->
          {{ toTitleCase(item.customer.user.firstnameEn) }}
          {{ toTitleCase(item.customer.user.lastnameEn) }}
        </span>
        <!-- </v-row> -->
      </template>
      <template v-slot:[`item.phone`]="{ item }">
        <span v-if="item.customer">
          {{ item.customer.user.phone }}
        </span>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <span v-if="item.createdAt">
          {{ new Date(parseInt(item.createdAt)) | moment("MMM DD YYYY") }}
        </span>
      </template>
      <template v-slot:[`item.modeDetails`]="{ item }">
        <PlanSwtichHistoryFullDetails :history="item" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import PlanSwtichHistoryFullDetails from "../../customer/components/salesOrder/PlanSwtichHistoryFullDetails.vue";
export default {
  components: { PlanSwtichHistoryFullDetails },

  methods: {
    toTitleCase(str) {
      if (!str) return "";
      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    onShowDialog() {
      this.getPlanSwitchHistory();
    },

    getPlanSwitchHistory() {
      this.loading = true;
      let filter = {
        searchKey: this.search,
        fieldToSearch: this.fieldToSearch,
        paymentStatus: this.paymentStatus,
      };
      this.$apollo
        .watchQuery({
          query: require("@/customer/components/salesOrder/api/getPlanSwitchHistory.graphql"),
          variables: {
            filter: filter,
            input: {
              skip: 0,
              limit: 25,
            },
          },
        })
        .refetch({
          variables: {
            filter: filter,
            input: {
              limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
              skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
            },
          },
        })
        .then(data => {
          this.loading = false;
          if (data.data) {
            this.history = data.data.getPlanSwitchHistory.planSwitchHistories;
            this.totalItems = data.data.getPlanSwitchHistory.totalCount;
          }
        });
    },
  },
  props: {
    subscription: {
      require: true,
    },
  },
  watch: {
    options: {
      handler() {
        this.getPlanSwitchHistory();
      },
      deep: true,
    },
  },
  created() {
    this.getPlanSwitchHistory();
  },

  data: () => ({
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    totalItems: 25,
    loading: true,
    history: [],
    show_dialog_box: false,
    paymentStatus: "",
    search: "",
    fieldToSearch: "PHONE",
    fieldsToSearch: [
      { key: "Customer Id", value: "CUSTOMER_ID" },
      { key: "Customer Name", value: "CUSTOMER_NAME" },
      { key: "Contact Number", value: "PHONE" },
    ],
    paymentStatuses: [
      { text: "Success", value: "SUCCESS" },
      { text: "Pending", value: "PENDING" },
    ],
    headers: [
      {
        text: "Si No",
        value: "siNo",
        sortable: false,
      },
      { text: "Customer", value: "customer" },
      { text: "Phone", value: "phone" },
      { text: "Created At", value: "createdAt" },
      { text: "Status", value: "status" },
      { text: "From Plan", value: "from.packageTitleEn" },
      { text: "To Plan", value: "to.packageTitleEn" },
      { text: "Updated By", value: "updatedBy" },
      { text: "More Details", value: "modeDetails" },
    ],
  }),
};
</script>
